import { motion } from "framer-motion";
import { ShoppingCart, CalendarDays, Video } from "lucide-react";
import { toast } from "@/components/ui/sonner";
import { useLanguage } from "@/context/LanguageContext";

const CALENDLY_URL = "https://calendar.app.google/C866HmTsf8RckhiE9";
const ACCENTS = ["#9B5DE5", "#F15BB5", "#00BBF9"];

export const Offers = () => {
  const { t } = useLanguage();
  const offers = t.offers.items;

  return (
    <section id="offers" className="py-20 lg:py-32 bg-[#FAFAF7]" data-testid="offers-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-14 max-w-xl"
        >
          <p className="font-['Ubuntu'] text-xs uppercase tracking-[0.25em] font-semibold text-[#F15BB5] mb-3">{t.offers.eyebrow}</p>
          <h2 className="font-['Cutive'] text-2xl sm:text-3xl lg:text-4xl font-bold">{t.offers.title}</h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {offers.map((offer, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              whileHover={{ y: -8 }}
              className="border-2 border-black rounded-2xl p-7 bg-white flex flex-col"
              data-testid={`offer-card-${i}`}
            >
              <span
                className="self-start font-['Ubuntu'] text-xs font-bold uppercase tracking-wide border-2 border-black rounded-full px-3 py-1 mb-5"
                style={{ backgroundColor: ACCENTS[i] }}
              >
                {offer.tag}
              </span>
              <h3 className="font-['Ubuntu'] text-xl font-bold mb-2">{offer.name}</h3>
              <p className="font-['Ubuntu'] text-sm text-black/60 mb-6 flex-1">{offer.desc}</p>
              <p className="font-['Cutive'] text-3xl font-bold mb-5">{offer.price}</p>

              {i === 0 && (
                <button
                  onClick={() => toast(t.offers.mockToast)}
                  className="inline-flex items-center justify-center gap-2 bg-black text-white font-['Ubuntu'] font-bold rounded-full px-5 py-3 hover:bg-[#9B5DE5] transition-colors"
                  data-testid="offer-cta-0"
                >
                  <ShoppingCart className="w-4 h-4" /> {offer.cta}
                </button>
              )}
              {i === 1 && (
                <button
                  onClick={() => document.getElementById("events")?.scrollIntoView({ behavior: "smooth" })}
                  className="inline-flex items-center justify-center gap-2 bg-black text-white font-['Ubuntu'] font-bold rounded-full px-5 py-3 hover:bg-[#9B5DE5] transition-colors"
                  data-testid="offer-cta-1"
                >
                  <Video className="w-4 h-4" /> {offer.cta}
                </button>
              )}
              {i === 2 && (
                <a
                  href={CALENDLY_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-black text-white font-['Ubuntu'] font-bold rounded-full px-5 py-3 hover:bg-[#9B5DE5] transition-colors"
                  data-testid="offer-cta-2"
                >
                  <CalendarDays className="w-4 h-4" /> {offer.cta}
                </a>
              )}
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
